import Group from "ol/layer/Group";
import LayerSwitcher from "ol-layerswitcher";
import { createBasemapTileLayers } from "../layers/basemapTileLayers";
import {
  getBasemapFromURL,
  registerBasemapLayers,
  resolveInitialBasemap,
} from "../state/URLStateManager";

export function addBasemapLayersAndControls(map, azureLoginControl) {
  const layerSwitcher = new LayerSwitcher({
    tipLabel: "Basemaps",
    groupSelectStyle: "none",
  });
  const tileLayers = createBasemapTileLayers(azureLoginControl);
  // The main viewer drives basemap selection via ol-layerswitcher, which needs
  // `title` + `type: "base"`. With no basemap in the URL, all layers start
  // visible and the switcher keeps the last one (Orbis). If the URL pins a
  // basemap, show only that one so the switcher keeps it instead.
  const initial = resolveInitialBasemap(
    tileLayers.map(({ name }) => name),
    getBasemapFromURL(),
  );
  tileLayers.forEach(({ name, layer }) => {
    layer.set("title", name);
    layer.set("type", "base");
    layer.setVisible(initial ? name === initial : true);
  });
  registerBasemapLayers(tileLayers);
  map.addLayer(
    new Group({
      title: "Base maps",
      layers: tileLayers.map(({ layer }) => layer),
    }),
  );
  map.addControl(layerSwitcher);
}
